import React from 'react';
import AppRoutes from '../../../config/AppRoutes';
import App_data from '../../../config/App_data';

function CaseCard(props) {
  const {
    chapter_name: chapterName,
    chapter_no,
    cfa3_essay_case,
    cfa3_2025_essay_case,
    router,
    // eslint-disable-next-line
    chapterOrder,
    index,
  } = props;
  const essayCases =  cfa3_essay_case ||
  cfa3_2025_essay_case;
  return (
    <div className='col-md-6 col-lg-6 col-xl-4 free-premium-section question_box'>
      <div
        className='question_bank_wrap pointer_class'
        onClick={() => {
          chapter_no &&
            chapterName &&
            router.push({
              pathname: AppRoutes.CFA3_ESSAY_QUESTION_CASES.replace(
                ':chapterID',
                chapter_no,
              ).replace(':chapterName', chapterName),
            });
        }}
      >
        <div className='margin_bottom_30'>
          <img src={`${App_data.frontend_url}/img/question_bank/icon2.svg`} width='54' alt='' />
        </div>
        <div className='question_title' value='2'>
          <a className='pointer_class' id='Behavioral Finance - Study Session 1'>
            {`${index + 1}. ${chapterName}`}
          </a>
        </div>
        <ul>
          <li>
            <span>
              <img
                src={`${App_data.frontend_url}/img/question_bank/free_question_icon.svg`}
                width='26'
                alt=''
              />
            </span>
            <span>
              {essayCases && essayCases.free_cases ? essayCases.free_cases : 0}
            </span>
            <div className='tootip_box'>Free cases</div>
          </li>
          <li>
            <span>
              <img
                src={`${App_data.frontend_url}/img/question_bank/premium_question_icon.svg`}
                width='23'
                alt=''
              />
            </span>
            <span>
              {essayCases && essayCases.premium_cases ? essayCases.premium_cases : 0}
            </span>
            <div className='tootip_box'>Premium cases</div>
          </li>
        </ul>
      </div>
    </div>
  );
}

export default CaseCard;



// WEBPACK FOOTER //
// ./src/views/CFA3/Cfa3EssayQuestions/Layout/CaseCard.jsx